export default "__VITE_ASSET__DhWGGr6y__"